import { render, staticRenderFns } from "./SubstanceInfo.vue?vue&type=template&id=bbad2380&scoped=true"
import script from "./SubstanceInfo.vue?vue&type=script&lang=js"
export * from "./SubstanceInfo.vue?vue&type=script&lang=js"
import style0 from "./SubstanceInfo.vue?vue&type=style&index=0&id=bbad2380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbad2380",
  null
  
)

export default component.exports